import pyFormTextArea from 'pylon-vue/src/components/form-textarea/form-textarea';

const sFormTextarea = {
    name: 'sFormTextarea',
    extends: pyFormTextArea
}

export default sFormTextarea